<script>
  export let playClick;

</script>

<style>
.root {
  flex: 1;
  display: flex;
  flex-direction: row;
  
  padding: 20px;

  /* for flexbox scroll */
  overflow: hidden;
}

@keyframes pulseOpacity {
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
}

.pulsing {
  animation: pulseOpacity 1.7s infinite ease-in-out;
}

.image {
  flex: 1;  

  display: flex;
  align-items: center;
  justify-content: center;  
}
.image svg {
  max-width: 250px;
}
.image:hover {
  opacity: .8;
  cursor: pointer;
}

.text {
  flex: 1;
  padding: 0 30px;
  color: white;
  font-size: 25px;
  line-height: 1.3;
  -ms-overflow-style: none;
  overflow: auto;  
}

@media (orientation: landscape) {  
  .text {
    display: flex;
    flex-direction: column;
    
    /** We want this when large **/
    justify-content: center;
  }

  .text2 {
    display: flex;
    flex-direction: column;

    /** In potrait we scroll the whole page **/
    overflow: auto;    
  }

  .image {
    flex: 1;
    max-width: 30vw;
  };
}

@media (orientation: portrait) {
  .root {
    flex-direction: column;
    justify-content: space-evenly;
  }
  .image {
    flex: 1;
    max-height: 40vh;
    min-height: 30vh;
  };

  .text {
    padding: 30px 0;
    flex: initial;
    align-self: center;
  }
}


h3 { 
  margin: 0;
  font-size: 35px;
  margin-bottom: 1em;
}
.size {
  margin: 1em 0;
  color: gray;
}
.author {
  margin: 1em 0;
  font-style: italic;
}
</style>

<div class="root">
  <div class="image pulsing" on:click={playClick}>
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
  width="100%" height="100%"
  viewBox="0 0 50 50"
  style=" fill: white;"><path d="M 10 5.25 L 10 44.746094 L 43.570313 25 Z"></path></svg>
  </div>

  <div class="text">
    <div class="text2">
      <h3>
        Invisible Hands
      </h3>
      <div>
        A documentary in three different parts, about the carpet weaving industry in Iran, with particular focus on the laborious process of hand-weaving, and the socio-economic position of the woman who do the work.
      </div>
      <div class="author">
        Armaghan Fatemi, 2019/2020
      </div>
    </div>
  </div>
</div>